import { createApiAction } from '@app/packages/api/utils'
import type { ApiCandidateSurvey } from '@app/packages/api/v2/types/entities'

export const getCandidateSurvey = () =>
  createApiAction('getCandidateSurvey', dispatch => dispatch<{ data: ApiCandidateSurvey | null }>({ method: 'GET', endpoint: '/api/v2/candidate_survey' }))
